import { Divider, Typography } from "@mui/material";
import styled from "styled-components";
import { Account, MASK_TYPE } from "types";
import AssetsDisplay from "pages/clientPortfolio/businessClient/businessClientSummary/components/AssetsDisplay";
import MaskedValue from "common/MaskedValue";

export default function AssetsSection(props: {
  assetsAccounts: Account[];
  assetsTotal: number;
}) {
  return (
    <div>
      <SectionHeading>
        <Typography variant={"h6"}>Assets</Typography>
      </SectionHeading>
      {props.assetsAccounts.length === 0 && <>No Asset Accounts</>}
      {props.assetsAccounts.length > 0 && (
        <>
          <AssetsDisplay accounts={props.assetsAccounts} />
          <Divider style={{ margin: "0.25em 0em 1.25em 0em" }} />
          <TotalBalanceRow>
            <LeftContent>Assets Total: </LeftContent>{" "}
            <RightContent>
              {MaskedValue(MASK_TYPE.MONEY, props.assetsTotal.toString())}
            </RightContent>
          </TotalBalanceRow>
        </>
      )}
    </div>
  );
}
const SectionHeading = styled.div`
  padding-bottom: 1em;
`;
const LeftContent = styled.div`
  font-weight: 500;
  width: 300px;
  flex: 1;
`;
const TotalBalanceRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0.5em 0em;
`;

const RightContent = styled.div`
  text-align: right;
  font-weight: 500;
`;
